<template>
  <div class="course-report">
    <transition-group name="fade">
      <div class="main" key="mian">
        <div class="left">
          <div class="left-select">
            <el-select popper-class="select-down" v-model="subject" @change="changeSubject">
              <el-option
                :label="item.name"
                :value="item.code"
                v-for="item in subjects"
                :key="item.code" />
            </el-select>
            <el-select
              v-if="reportType !== 'ordinary'"
              class="left-classify" popper-class="select-down"
              v-model="classify" @change="changeClassify">
              <el-option
                :label="item.name"
                :value="item.code"
                v-for="item in classifyList"
                :key="item.code" />
            </el-select>
          </div>
          <template v-if="!(reportType === 'free')">
            <div class="title">
              <span class="vertical-line"></span>
              <span>{{isEnglish ? '单词学习报告' : '学习统计'}}</span>
            </div>
            <div class="word-report card">
              <div class="tabel-title">
                <i
                  :class="{hide: reportType === 'ordinary'}"
                  class="el-icon-arrow-left"
                  @click="toggleEchart"
                />
                {{isEnglish ? '单词学习统计' : '近7次考试成绩'}}
                <i
                  :class="{hide: reportType === 'ordinary'}"
                  class="el-icon-arrow-right"
                  @click="toggleEchart"
                />
              </div>
              <div class="echarts">
                <div class="chart" ref="line"></div>
              </div>
            </div>
            <div class="title">
              <span class="vertical-line"></span>
              <span>总览</span>
            </div>
            <div v-if="isEnglish" class="overview">
              <div class="card">
                <span>{{overview.learn_word_count || 0}}个</span>
                <span>已学单词</span>
              </div>
              <div class="card">
                <span>{{overview.learn_examination_count || 0}}个</span>
                <span>已做测试</span>
              </div>
              <div class="card">
                <span>{{overview.grasp_word_count || 0}}个</span>
                <span>已掌握单词</span>
              </div>
              <div class="card">
                <span>{{overview.trophy_count || 0}}个</span>
                <span>获得奖状数量</span>
              </div>
            </div>
            <div v-else class="overview">
              <div class="card">
                <span>{{overview.learn_knowledge_count || 0}}个</span>
                <span>已学知识点</span>
              </div>
              <div class="card">
                <span>{{overview.wrong_note_count || 0}}个</span>
                <span>当前错题</span>
              </div>
              <p class="card">
                已做<span>{{overview.test_count || 0}}</span>套试卷，其中满分
                <span>{{overview.test_full_mark_count}}</span>次！
              </p>
            </div>
          </template>
        </div>
        <div class="right">
          <div class="tip">
            <div class="card">
              <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/2af2910482ed974e75a42236030173b4.png" />
              <span>汇总了您近期知识点的学习以及考试记录等内容。</span>
            </div>
            <img class="close" @click="close" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/e4f688b8d4e34ef78964f2cef65f5138.png" alt="" />
          </div>
          <!-- 非自由组合 -->
          <template v-if="!(reportType === 'free')">
            <div class="test-result">
              <div class="title">
                <span class="vertical-line"></span>
                <span>{{isEnglish ? '测试成绩' : '考试记录'}}</span>
              </div>
              <div class="condition">
                <el-date-picker
                  class="date"
                  v-model="date"
                  @change="changeDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
                <el-select
                  v-if="reportType === 'ordinary'"
                  popper-class="book-select-down"
                  v-model="bookId"
                  @change="changeBook"
                >
                  <el-option
                    :label="item.name"
                    :value="item.id"
                    v-for="item in books"
                    :key="item.id" />
                </el-select>
              </div>
            </div>
            <div v-if="testResults.length" class="records">
              <div class="card record" v-for="item in testResults"
                :key="item.after_test_id || item.id"
                @click="checkDetail(item)"
              >
                <div class="record-left">
                  <h2>{{reportType === 'ordinary' ? item.name : item.unit_name}}</h2>
                  <div v-if="item.test_type" class="icon-title">
                    <i class="el-icon-collection" />
                    <span>{{item.test_type}}</span>
                  </div>
                  <div class="record-time">
                    <div class="icon-title">
                      <i class="el-icon-time" />
                      <span>测试时间：
                        {{reportType === 'ordinary' ? item.updated : item.test_time}}
                      </span>
                    </div>
                    <div class="icon-title">
                      <i class="el-icon-time" />
                      <span>测试耗时：{{reportType === 'ordinary'
                        ? item.spend_time : item.time_consuming}}</span>
                    </div>
                  </div>
                </div>
                <div class="record-right">
                  <span>{{reportType === 'ordinary' ? item.accuracy : item.score}}分</span>
                </div>
                <img v-if="item.trophy_id" class="medal" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/ffd45d114b2c5b8e36eada301bf67261.png" alt="" />
                <span
                  v-if="reportType === 'word' && item.trophy_id"
                  class="certificate"
                  @click.stop="showCertificate(item)"
                >
                  查看证书
                </span>
                <span
                  v-if="reportType === 'ordinary'"
                  class="certificate"
                >
                  查看报告
                </span>
              </div>
            </div>
            <div v-else class="no-data">暂无考试记录，快去考试吧！</div>
            <van-page class="page" :total="total" :page-size="pageSize" @changePage="changePage" />
          </template>
          <!-- 自由组合 -->
          <free-report v-if="reportType === 'free' && classify" :classify="classify" class="card" />
        </div>
      </div>
      <van-bdc-exam-detail
        class="bdc-dialog"
        :scene="5"
        :is-comparison="isComparison"
        :isExamRecords="true"
        :exercises="examQuizzes"
        :extend-exercises="afterExamQuizzes"
        :navigation="navigation"
        :scores="scores"
        key="wordExamDetails"
        ref="examDialog" />
    </transition-group>
    <van-certificate
      :info="reportInfo"
      v-if="isShowCertificate"
      :is-replay="false"
      @close="isShowCertificate = false"
    />
  </div>
</template>

<script>
/* eslint-disable */
import { Select, Option, Input, Pagination, Button, DatePicker } from 'element-ui';
import * as echarts from 'echarts';
import api from '@/api/graphql/englishCourse';
import report from '@/api/report';
import course from '@/api/course';
import utils from '@/services/utils';
import FreeReport from './FreeReport.vue';
import VanCertificate from '@/components/quizzes/bdc/Certificate.vue';
import VanBdcExamDetail from '@/components/quizzes/bdc/ExamDialog.vue';
import VanPage from '../personal/Page.vue';
import VanDialog from '../personal/Dialog.vue';

export default {
  components: {
    VanPage,
    VanDialog,
    FreeReport,
    VanBdcExamDetail,
    VanCertificate,
    ElSelect: Select,
    ElOption: Option,
    ElInput: Input,
    ElPagination: Pagination,
    ElButton: Button,
    ElDatePicker: DatePicker,
  },
  props: {
    params: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      subject: '',
      classify: '',
      date: '',
      overview: {},
      freeData: {},
      subjects: [],
      classifyList: [],
      testResults: [],
      examQuizzes: [],
      scores: [],
      afterExamQuizzes: [],
      bookId: '',
      books: [],
      reportInfo: {},
      isComparison: false,
      isShowCertificate: false,
      wordEchartsType: 'word',
      total: 0,
      page: 1,
      pageSize: 4,
      navigation: '',
    };
  },
  computed: {
    isEnglish() {
      return this.subject === 'English';
    },
    reportType() {
      let reportType; // ordinary史地生  word单词  free自由组合
      if (this.subject === 'English' && (this.classify === 'vocabulary' || this.classify === 'ENGLISH_GXYD')) {
        reportType = 'word';
      } else if (this.subject === 'English'
        || this.subject === 'Chinese'
        || this.subject === 'Chemistry') {
        reportType = 'free';
      } else {
        reportType = 'ordinary';
      }
      return reportType;
    },
  },
  methods: {
    changeBook() {
      this.page = 1;
      this.getTestResults();
      this.getSevenExamRecord();
      this.getOverview();
    },
    changeSubject() {
      this.page = 1;
      if (this.reportType === 'free' || this.reportType === 'word') {
        this.getClassifyList();
      } else {
        this.getBooks();
      }
    },
    changeClassify() {
      this.page = 1;
      if (this.reportType === 'word') {
        this.getWeekWords();
        this.getTestResults();
        this.getOverview();
      }
    },
    changeDate() {
      this.page = 1;
      this.getTestResults();
    },
    close() {
      this.$emit('close');
    },
    changePage(curPage) {
      this.page = curPage;
      this.getTestResults();
    },
    getLearnData(exam) {
      /* eslint-disable */
      const curSubject = utils.Array.find(this.subjects, { code: this.subject }, 'code');
      const curBook = utils.Array.find(this.books, { id: this.bookId }, 'id');

      const { score, ...params } = exam;
      this.$emit('change', {
        scene: 'quizzesDialog',
        params: {
          course: {
            id: this.bookId,
            projectCode: curSubject.template_code,
            name: curBook.name,
            type: this.subject,
          },
          ...params,
          score: score ? Number(score) : 0,
        },
      });
    },
    showCertificate(exam) {
      if (this.reportType !== 'ordinary') {
        const { id } = utils.storage('account');
        report.getTestTrophy({
          student_id: id,
          examination_id: exam.after_test_id || exam.id,
        })
          .then((data) => {
            this.reportInfo = {
              unitName: data.unit_name,
              name: data.user_name,
              courseName: data.book_name,
              score: data.accuracy,
              schoolName: data.school_name,
              time: data.submit_time,
              certificateId: exam.after_test_id || exam.id,
            };
            this.isShowCertificate = true;
          })
      }
    },
    getTestResults() {
      if (this.reportType === 'word') {
        report.getTestResults({
          subject_code: this.classify,
          now_page: this.page,
          per_page: this.pageSize,
          time: this.date,
        })
          .then((data) => {
            this.total = data.total;
            this.testResults = data.data;
          })
      }
      if (this.reportType === 'ordinary') {
        report.getTestsStatistic({
          book_id: this.bookId,
          now_page: this.page,
          per_page: this.pageSize,
          test_name: '',
          time: this.date,
        })
          .then((data) => {
            this.total = data.count;
            this.testResults = data.data;
          })
      }
    },
    getSubjectList() {
      report.getSubjects()
        .then((data) => {
          this.subject = this.cache.subject || data[0].code;
          this.subjects = data;
          if (this.reportType === 'ordinary') {
            this.getBooks(true);
          } else {
            this.getClassifyList(true);
          }
        })
    },
    getClassifyList(isinitialLoad = false) {
      course.getSubjectList({
        project_code: this.subject
      })
        .then((data) => {
          this.classify = isinitialLoad
            ? this.cache.classify || data[0].code
            : data[0].code;
          this.classifyList = data;
          if (this.reportType !== 'free') {
            this.getWeekWords();
            this.getOverview();
            this.getTestResults();
          }
        })
    },
    getOverview() {
      if (this.reportType === 'word') {
        report.getEnglishOverview({
          subject_code: this.classify,
        }).then((data) => {
          this.overview = data;
        });
      } else {
        report.getOtherOverview({
          book_id: this.bookId,
        }).then((data) => {
          this.overview = data;
        });
      }
    },
    getWeekWords() {
      report.getWeekWords({
        subject_code: this.classify,
      }).then((data) => {
        this.renderTimeChart(data)
      });
    },
    getWeekWordTime() {
      report.getWeekWordTime({
        subject_code: this.classify,
      }).then((data) => {
        this.renderTimeChart(data)
      });
    },
    getBooks(isinitialLoad = false) {
      report.getBooks({
        project_code: this.subject,
        book_name: '',
      }).then((data) => {
        this.books = data;
        if (data.length) {
          this.bookId = isinitialLoad
            ? this.cache.bookId || data[0].id
            : data[0].id;
          this.getOverview();
          this.getSevenExamRecord();
          this.getTestResults();
        } else {
          this.bookId = '';
        }
      });
    },
    getSevenExamRecord() {
      report.getSevenExamRecord({
        book_id: this.bookId,
      }).then((data) => {
        this.freeData = {};
        if (data.length) {
          data.forEach((item) => {
            this.freeData[item.updated] = item.accuracy;
          });
          this.renderTimeChart(this.freeData, true);
        } else {
          this.renderTimeChart(this.freeData);
        }
      });
    },
    renderTimeChart(data, reversal = false) {
      const chartDom = this.$refs.line;
      const myChart = echarts.init(chartDom);
      let echartName;
      if (this.reportType === 'word') {
        this.wordEchartsType === 'word'
          ? echartName = '单词数量'
          : echartName = '学习时间';
      } else {
        echartName = '考试成绩';
      }

      const option = {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: reversal ? Object.keys(data).reverse() : Object.keys(data),
          axisLine: {
            lineStyle: {
              color: '#E9EFF3',
            }
          },
          axisLabel: {
            formatter: (value) => {
              if (value.length > 10) {
                const dates = value.split(' ')[0].split('-');
                const times = value.split(' ')[1].split(':');
                return `${dates[1]}-${dates[2]}\n${times[0]}:${times[1]}`;
              }
              return value;
            },
            color: '#5A5FEF',
            margin: 20,
          },
          axisTick: {
            show: false,
          },
        },
        tooltip: {
          trigger: 'axis',
        },
        toolbox: {
          show: true,
          left: '0%',
          itemSize: 22,
          itemGap: 15,
          iconStyle:{
            borderColor: '#5A5FEF',
            borderWidth: 1,
          },
          feature: {
            magicType: {
              type: ['line', 'bar'],
            },
            saveAsImage: {}
          },
        },
        legend: {
          data: [echartName],
          textStyle: {
            color: '#117CF7',
            fontSize: 16,
          },
          top: '6px',
          right: '0px',
          selectedMode: false,
        },
        grid: {
          top: '60px',
          left: '0%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          splitNumber: 4,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#5A5FEF',
            }
          },
          splitLine: {
            show: true,
            lineStyle:{
              color: '#E9EFF3',
              width: 1,
              type: 'solid'
            }
          },
          axisLabel: {
            color: '#5A5FEF',
            margin: 20,
          },
        },
        series: [{
          name: echartName,
          data: reversal ? Object.values(data).reverse() : Object.values(data),
          type: 'line',
          color: '#117CF7',
          showSymbol: false,
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#ADCBF8' },
                { offset: 1, color: '#F2F5F9' }
              ])
            }
          },
        }],
      };
      myChart.setOption(option, true);
      window.onresize = myChart.resize;
    },
    toggleEchart() {
      if (this.wordEchartsType === 'word') {
        this.getWeekWordTime();
        this.wordEchartsType = 'time';
        return;
      }
      this.wordEchartsType = 'word';
      this.getWeekWords();
    },
    checkDetail(exam) {
      if (this.subject !== 'English' && this.reportType === 'ordinary') {
        this.getLearnData({
          type: 'reportExamFDetails',
          isExamRecords: 1,
          score: exam.accuracy,
          examId: exam.assessment_id,
          payload: exam,
        });
        return;
      }

      const { id, unit_name, after_test_id } = exam;
      this.afterExamQuizzes = [];
      let promise;
      if (after_test_id) {
        this.isComparison = true;
        promise = api.getDiffExamDetail({
          type: 'new',
          beforeExamId: id,
          afterExamId: after_test_id,
        });
      } else {
        this.isComparison = false;
        promise = api.getExamDetail({
          examId: id,
          type: 'new'
        });
      }
      promise
        .then((response) => {
          const data = response.diffEnglishExamDetail || [response.englishExamDetail];
          const [beforeDetail, afterDetail] = data;
          const scores = [];

          scores.push(beforeDetail.score);
          this.examQuizzes = beforeDetail.quizzes.map((item) => {
            const userAnswer = item.userAnswer;
            return {
              ...item,
              userAnswer,
            };
          });

          if (afterDetail) {
            scores.push(afterDetail.score);
            this.afterExamQuizzes = afterDetail.quizzes.map((item) => {
              const userAnswer = item.userAnswer;
              return {
                ...item,
                userAnswer,
              };
            });
          }

          this.scores = scores;
          this.navigation = unit_name;
          this.$refs.examDialog.open();
        });
    },
  },
  created() {
    this.cache = JSON.parse(sessionStorage.getItem('report')) || {};
    this.getSubjectList();
  },
  beforeDestroy() {
    const optios = {
      subject: this.subject,
      classify: this.reportType !== 'ordinary' ? this.classify : null,
      bookId: this.reportType === 'ordinary' ? this.bookId : null,
    };
    sessionStorage.setItem('report', JSON.stringify(optios));
  }
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .course-report {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .main {
      margin: 2% auto 0;
      padding: 30px;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      width: 90%;
      height: 90%;
      background-color: #fff;
      border-radius: 24px;
      .card {
        border-radius: 18px;
        box-shadow: 0px 0px 10px rgba(0, 56, 216, 0.3);
      }
      .title {
        position: relative;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        line-height: 8vh;
        font-size: 2vh;
        font-weight: 700;
        .vertical-line {
          display: inline-block;
          width: 3px;
          height: 15px;
          margin-right: 1vh;
          background: $primary;
          border-radius: 18px;
        }
      }
      .left {
        width: 28%;
        height: 100%;
        &-select {
          height: 8%;
          .left-classify {
            margin-left: 10%;
          }
          /deep/ .el-select {
            width: 40%;
            height: 100%;
            .is-focus {
              .el-input__inner {
                border-color: $primary;
              }
            }
            .el-input {
              height: 100%;
              .el-input__inner {
                &:focus {
                  border-color: $primary;
                }
                height: 100%;
                text-align: center;
                color: $primary;
                font-size: 2.5vh;
                font-weight: 700;
                border-radius: 20px;
                box-shadow: 0px 0px 10px rgba(0, 56, 216, 0.3);
              }
              .el-input__suffix {
                .el-input__suffix-inner {
                  .el-select__caret {
                    font-size: 2vh;
                    font-weight: 700;
                    color: $primary;
                  }
                }
              }
            }
          }
        }
        .word-report {
          padding: 4%;
          box-sizing: border-box;
          height: 45%;
          .tabel-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 2vh;
            i {
              padding: 1%;
              color: #5A5FEF;
              font-weight: bold;
              font-size: 3vh;
              cursor: pointer;
              border-radius: 50%;
              background-color: #ebecfd;
            }
            .hide {
              visibility: hidden;
            }
          }
          .tabel-tool {
            margin-top: 2vh;
            img {
              margin-right: 15px;
              position: relative;
              width: 20px;
              z-index: 1;
              cursor: pointer;
            }
          }
          .echarts {
            position: relative;
            top: 3%;
            height: 86%;
            width: 100%;
            .chart {
              height: 100%;
              width: 100%;
            }
          }
        }
        .overview {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          height: 24%;
          div {
            margin-bottom: 6%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 46%;
            height: 50%;
            span:first-child {
              padding-bottom: 5%;
              font-size: 3vh;
              color: $primary;
            }
            span:last-child {
              font-size: 2vh;
            }
          }
          p {
            margin: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 50%;
            font-size: 2vh;
            span {
              color: $primary;
              font-size: 3vh;
            }
          }
        }
      }
      .right {
        width: 69%;
        height: 100%;
        .tip {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          height: 8%;
          div {
            padding: 0 2%;
            display: flex;
            align-items: center;
            width: 88%;
            height: 100%;
            img {
              height: 50%;
            }
            span {
              margin-left: 2%;
              font-size: 2.5vh;
              color: $primary;
            }
          }
          .close {
            cursor: pointer;
          }
        }
        .test-result {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .condition {
            .date {
              width: 150px;
              /deep/ .el-input__inner {
                &:focus {
                  border-color: $primary;
                }
                color: $primary;
                font-weight: 700;
                border-radius: 12px;
              }
              /deep/ .el-input__prefix {
                font-size: 2vh;
                color: $primary;
              }
            }
            /deep/ .el-select {
              margin-left: 30px;
              width: 150px;
              .is-focus {
                .el-input__inner {
                  border-color: $primary;
                }
              }
              .el-input {
                .el-input__inner {
                  &:focus {
                    border-color: $primary;
                  }
                  color: $primary;
                  font-weight: 700;
                  border-radius: 12px;
                }
                .el-input__suffix {
                  .el-input__suffix-inner {
                    .el-select__caret {
                      font-weight: 700;
                      color: $primary;
                    }
                  }
                }
              }
            }
          }
        }
        .records {
          display: flex;
          flex-direction: column;
          height: 64vh;
          .record {
            margin-bottom: 2vh;
            padding: 2vh;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-sizing: border-box;
            height: 14.5vh;
            &:hover {
              color: #fff!important;
              background-color: #5A5FEF!important;
              cursor: pointer;
              .icon-title {
                i {
                  color: #fff;
                }
              }
              .certificate {
                color: $primary;
                background-color: #fff;
              }
              .record-right {
                span {
                  color: #fff;
                }
              }
            }
            .medal {
              position: absolute;
              width: 4%;
              top: 0;
              right: 15%;
            }
            &-left {
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              height: 100%;
              width: 80%;
              h2 {
                margin: 0;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
              }
            }
            &-right {
              span {
                font-size: 3vh;
                color: $primary;
              }
            }
            &-time {
              display: flex;
            }
            .icon-title {
              display: flex;
              align-items: center;
              i {
                font-size: 2.5vh;
                color: #5A5FEF;
              }
              span {
                margin-left: 10px;
                margin-right: 20px;
                font-size: 1.8vh;
              }
            }
            .certificate {
              padding: 1vh 3vh;
              position: absolute;
              bottom: 0;
              right: 0;
              font-size: 1.5vh;
              color: #fff;
              cursor: pointer;
              border-bottom-right-radius: 18px;
              border-top-left-radius: 18px;
              background-color: #646DE2;
            }
          }
        }
        .no-data {
          margin-top: 20%;
          text-align: center;
          font-size: 3vh;
          font-weight: bold;
          color: #5A5FEF;
        }
        .page {
          margin-top: 1vh;
        }
      }
    }
    /deep/ .mask {
      left: 0%;
      top: 0%;
    }
    /deep/ .bdc-dialog {
      .dctx-container {
        .main {
          .text-input {
            top: 22px!important;
          }
        }
      }
      .article-exam-detail {
        display: flex;
        flex-direction: column;
        .ydlj-container {
          .article-wrap {
            width: 50%;
          }
        }
      }
    }
    .fade-enter-active, .fade-leave-active {
      transition: all 1s;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }
  }
  .select-down {
    .el-scrollbar {
      .el-select-dropdown__wrap {
        .el-scrollbar__view {
          .el-select-dropdown__item {
            font-size: 2vh;
          }
          .selected {
            color: $primary;
          }
        }
      }
    }
  }
  .book-select-down {
    .el-scrollbar {
      .el-select-dropdown__wrap {
        .el-scrollbar__view {
          .el-select-dropdown__item {
            font-size: 1vh;
          }
          .selected {
            color: $primary;
          }
        }
      }
    }
  }
</style>
